import { memo, useMemo } from 'react';
import NumberLineElementEleve from '../../VueEvalNat/BilanEval/FormBilanEval/FormQuestion/Elements/NumberLineElementEleve';

/**
 * Preview prof : droite graduée avec les points placés aux bonnes positions (vert).
 * Réutilise NumberLineElementEleve en lecture seule.
 *
 * @param {Object} numberline - Config { start, end, step }
 * @param {string} bonneReponse - JSON string { "X": "3,5", "Y": "7" }
 */
const PlacerPointsRenderer = memo(function PlacerPointsRenderer({ numberline, bonneReponse, light }) {
    const config = useMemo(() => {
        let points = [];
        try {
            const obj = JSON.parse(bonneReponse);
            points = Object.entries(obj).map(([label, val]) => ({
                value: parseFloat(String(val).replace(',', '.')),
                label,
                showValue: true,
                color: '#22c55e',
            }));
        } catch { /* ignore */ }

        return { ...numberline, points, showArrow: true, showStart: true, showEnd: true };
    }, [numberline, bonneReponse]);

    // Garde-fou : config de droite graduée manquante/malformée → placeholder propre
    // (évite un rendu vide/dégénéré dans l'aperçu prof et la correction).
    if (!numberline || numberline.start == null || numberline.end == null) {
        return <p className={`text-xs italic ${light ? 'text-gray-400' : 'text-slate-400'}`}>Droite graduée indisponible</p>;
    }

    return (
        <div>
            <span className={`text-[10px] font-semibold uppercase tracking-wider mb-2 block ${light ? 'text-gray-400' : 'text-slate-400'}`}>
                Points à placer
            </span>
            <NumberLineElementEleve config={config} />
        </div>
    );
});

export default PlacerPointsRenderer;
